import  { useState } from "react";
import Header from "../../../Layout/Header";
import { useTranslation } from "react-i18next";
import { Divider, Box,  useTheme,  Grid,  TextField, Typography, Table, TableCell, TableBody, TableContainer, TableHead, TableRow, Card, CardContent,  } from "@mui/material";


import LabelChildRollDetails from "../labels/ChildRoll";
import LabelPalletDetails from "../labels/Pallet";
import LabelReamDetails from "../labels/Ream";
import LabelParentRollDetails from "../labels/ParentRoll";
import LabelBundleDetails from "../labels/Bundle";
import LabelReamPalletDetails from "../labels/ReamPallet";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";


const PrintProductCodes = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();    

    const [searchValue, setSearchValue] = useState('');
    const [productList, setProductList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');

  

    // State for the QR code value
    const [qrCodeValue, setQRCodeValue] = useState('Netique infotech');
    const [selectedProductDetails, setSelectedProductDetails] = useState([]);

    const FilterProductDetail = (searchvalue) => {

        if (searchvalue != '') {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_search_product: searchvalue
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SEARCH_PRODUCT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setProductList(data);
                    }
                    else {
                        setProductList([]);
                        setSelectedProduct('');
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        else {
            setProductList([]);
            setSelectedProduct('');
        }

    };


    const handleGetProductDetails = (product_id, product_code, product_type) => {

        setSelectedProduct(product_type);

        if (product_type === 'CHILD ROLL') {
            ChildRollProductDetail(product_code);
        }
        else if (product_type === 'PARENT ROLL')
        {
            ParentRollProductDetail(product_code);
        }            
        else if (product_type === 'PALLET') {
            PalletProductDetail(product_code);
        }
        else if (product_type === 'REAM') {
            ReamProductDetail(product_code);
        }
        else if(product_type === 'BUNDLE') {
            BundleProductDetail(product_code);
        }
        else if(product_type === 'REAM PALLET') {
            ReamPalletProductDetail(product_code);
        }

    };


    // get child roll details
    const ParentRollProductDetail = (ParentRollNumber) => {
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_pr_number: ParentRollNumber,
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_PARENT_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    setSelectedProductDetails(data);
                }
                else {

                }

            })
            .catch(error => {
                // Update state with error message        
                // setSheeterSeverityvalue('error');
                // setSheeterMessageValue(error.message);
                // setSheeterAlertTitleValue('Error');
                // setSheeterMsgOpen(true);
            });
    };



    // get child roll details
    const ChildRollProductDetail = (ChildRollNumber) => {
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_child_reel_number: ChildRollNumber,
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {

                    setSelectedProductDetails(data[0]);
                    const qrValue = `Child Roll No: ${data[0].child_reel_number || 'XXXXXX0123'}, ` +
                        `Quality: ${data[0].item_code || 'XXXXQuality'}, ` +
                        `Size: ${data[0].width || '0'} X ${data[0].length}, ` +
                        `GSM: ${data[0].gsm}, BF: ${data[0].bf || 0}, ` +
                        `ID/OD: ${data[0].core_id || 0} / ${data[0].reel_od || 0}, ` +
                        `Roll.wt: ${data[0].achieved_qty || 0}(Mt), ` +
                        `Reel Length: ${data[0].reel_length || 0} meters, ` +
                        `Customer Number: ${data[0].customer_code || 'XXXXXXX'}`;

                    setQRCodeValue(qrValue);
                }
                else {

                }

            })
            .catch(error => {
                // Update state with error message        
                // setSheeterSeverityvalue('error');
                // setSheeterMessageValue(error.message);
                // setSheeterAlertTitleValue('Error');
                // setSheeterMsgOpen(true);
            });
    };

    // get pallet details
    const PalletProductDetail = (PalletNumber) => {
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_pallet_number: PalletNumber,
            p_mode:0,
            p_child_reel_number:''
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    setSelectedProductDetails(data);
                }
            })
            .catch(error => {
                alert(error.message);
            });

    };

    const ReamProductDetail = async (ReamNumber) => {

        if (ReamNumber != '') {


            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_ream_number: ReamNumber,
                p_mode:0,
                p_pallet_id:0
            };

            await callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setSelectedProductDetails(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }

    };

    const BundleProductDetail = async (BundleNumber) => {

        if (BundleNumber != '') {


            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_bundle_number: BundleNumber,
                p_mode:0,
                p_pallet_id:0,
            };

            await callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_BUNDLE_DETAIL_PRINT, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setSelectedProductDetails(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }

    };

    const ReamPalletProductDetail= async (ReamPalletNumber) => {

        if (ReamPalletNumber != '') {


            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_bundle_number: ReamPalletNumber,
                p_mode:0,
                p_pallet_id:0,
            };

            await callApi(API_ENDPOINTS.PROD_MANAGEMENT_SEARCH_GET_REAM_PALLET_DETAIL_PRINT, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setSelectedProductDetails(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }

    };




    return (<>
        <Header title={t('prod_menu.printqrcode')} subtitle="" callback={handleBackWinderMachineEntry} />
        <Divider />
        <Grid container>
            <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                <Grid container padding="5px 10px 0px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                    <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                        <Typography variant="h6" > Please Enter Product Code </Typography>
                    </Grid>

                    {/* <Grid item xs={12} sm={11} md={3.8} lg={3.8} xl={2.5}>
                        <RadioGroup row value={selectedProductType} onChange={handleProductTypeChange}>
                            <FormControlLabel value="child" control={< Radio size="small" color="secondary" />} label="Child Roll" />
                            <FormControlLabel value="pallet" control={<Radio size="small" color="secondary" />} label="Pallet" />
                            <FormControlLabel value="ream" control={<Radio size="small" color="secondary" />} label="Reams" />
                            <FormControlLabel value="bundle" control={<Radio size="small" color="secondary" />} label="Bundle" />
                        </RadioGroup>
                    </Grid> */}

                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                        <TextField fullWidth value={searchValue} size="small" onChange={(e) => { setSearchValue(e.target.value); FilterProductDetail(e.target.value); }} type='text' />
                    </Grid>
                </Grid>
            </Grid>
            <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                <Divider />
            </Grid>

            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}>
                <Grid item sm={11} md={11} lg={6.2} xl={5}>
                    <Box
                        gridColumn="span 9"
                        gridRow={"span 2"}
                        alignItems="center"
                        justifyContent="center"
                        padding={1}
                        sx={{
                            "& .MuiTable-root": {
                                border: "none",
                                size: "small",
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "none",

                                border: "1px solid ",
                                borderColor: `${colors.primary[400]} !important`,
                            },
                            "& .name-column--cell": {
                                color: colors.greenAccent[300],
                            },
                            "& .MuiTableHead-root": {

                                borderBottom: "none",


                            },
                            "& .MuiTableBody-root": {
                                overflowY: "auto",
                            },
                            "& .MuiCheckbox-root": {
                                color: `${colors.blueAccent[200]} !important`,
                                size: "small",
                            },
                            "& .MuiTableFooter-root": {
                                borderTop: "none",
                                backgroundColor: colors.blueAccent[700],
                                height: "10px",
                            },
                            "& .MuiButton-text": {
                                color: `${colors.grey[100]} !important`,
                            },

                        }}>

                        <TableContainer >
                            <Table size="small">
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>
                                        <TableCell>PRODUCT CODE</TableCell>
                                        <TableCell>PRODUCT TYPE</TableCell>
                                        <TableCell>PRODUCED DATE</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productList.map((row) => (
                                        // {slotList.map((row) => (
                                        <TableRow key={row.id}>

                                            <TableCell>
                                                <span
                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                    onClick={() => handleGetProductDetails(row.id, row.product_code, row.product_type)}
                                                >
                                                    {row.product_code}
                                                </span>
                                            </TableCell>
                                            <TableCell>{row.product_type}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Grid>
                <Grid item sm={11} md={11} lg={5.5} xl={3.8}>
                    <Box>
                        {selectedProduct != '' && (
                            <Card>
                                <CardContent>
                                    <Box sx={{ p: 1 }}>
                                        {selectedProduct === 'CHILD ROLL' ? (
                                            <LabelChildRollDetails qrCodeValue={qrCodeValue} selectedProductDetails={selectedProductDetails} company_id={localStorage.getItem('companyid')} mode={0} modulename='Print Product Code'/>
                                        ) : selectedProduct === 'PALLET' ? (
                                            <LabelPalletDetails qrCodeValue={qrCodeValue} ProductDetail={selectedProductDetails}  />
                                        ) : selectedProduct === 'REAM' ? (
                                            <LabelReamDetails qrCodeValue={qrCodeValue} ProductDetail={selectedProductDetails} company_id={localStorage.getItem('companyid')} />
                                        ) : selectedProduct === 'PARENT ROLL' ? (
                                            <LabelParentRollDetails qrCodeValue={qrCodeValue} ProductDetail={selectedProductDetails} company_id={1} />
                                        ) : selectedProduct === 'BUNDLE' ? (
                                            <LabelBundleDetails qrCodeValue={qrCodeValue} ProductDetail={selectedProductDetails} company_id={localStorage.getItem('companyid')} />
                                        ) : selectedProduct === 'REAM PALLET' ? (
                                            <LabelReamPalletDetails qrCodeValue={qrCodeValue} ProductDetail={selectedProductDetails} />
                                        ) : null}
                                    </Box>
                                </CardContent>
                            </Card>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Grid>

    </>);
};
export default PrintProductCodes;